import { DetailedHTMLProps, ElementType, FC, HTMLAttributes, ReactNode, useMemo } from 'react'
import ReactModal, { Props as TReactModalProps } from 'react-modal'
import { StyledComponent } from '@emotion/styled'
import { Theme } from '@emotion/react'

import { DefaultReactModalStyleContainer } from './LibModal.styles'

ReactModal.setAppElement('*') // suppresses modal-related test warnings.

type TLibraryModal = TReactModalProps & {
    children?: ReactNode
    showCloseIcon?: boolean
    closeModal: () => void
    ReactModalStyleContainer?: StyledComponent<
        { theme?: Theme; as?: ElementType },
        DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
    >
}

const LibModal: FC<TLibraryModal> = ({
    closeModal,
    showCloseIcon = true,
    children,
    ReactModalStyleContainer = DefaultReactModalStyleContainer,
    ...props
}) => {
    const ModalContent = useMemo(
        () => (modalContentProps, modalContentChildren) =>
            (
                <ReactModalStyleContainer {...modalContentProps}>
                    {showCloseIcon &&
                        <button className="modal-close-button" type="button" onClick={closeModal}>
                            <img src="/images/icons/close.svg" alt="close" />
                        </button>
                    }

                    {modalContentChildren}
                </ReactModalStyleContainer>
            ),
        [ReactModalStyleContainer],
    )

    return (
        <ReactModal contentElement={ModalContent} {...props}>
            {children}
        </ReactModal>
    )
}

export type { TLibraryModal }
export { LibModal }
